module.exports = "pegasus/assets/text_library_block.png";